export const normalizePecId = (value: string) => {
  const match = value && value.match(/[-\d]\d{0,8}/);
  return match ? match[0] : '';
};
